import { MachineActions } from 'common/bento/types/MachineConfig';
import webView from 'common/webView';
import logger from 'helpers/logger';

import { Model } from './model';

export enum Action {
  LogUnexpectedState = 'logUnexpectedState',
  TriggerOnboardingCompletedMessage = 'triggerOnboardingCompletedMessage',
}

const actions: MachineActions<Model, Action> = {
  logUnexpectedState: () => {
    logger.error(`Unexpected state for this shine start dossier`);
  },

  triggerOnboardingCompletedMessage: ({ getModuleData }) => {
    const { companyProfileId = '', companyUserId = '' } =
      getModuleData().companyContext;

    return webView.postMessage({
      action: 'ONBOARDING_COMPLETED',
      payload: { companyProfileId, companyUserId },
    });
  },
};

export default actions;
